import { createAction } from '@reduxjs/toolkit'
import { IUser } from './types'

export const toggleTheme = createAction<void>('user/toggleTheme')
export const setUser = createAction<IUser>('user/save')
export const setUserLoader = createAction<{ authLoading: boolean }>('user/setUserLoader')
export const setTotalTokenClaimed = createAction<{ totalTokenClaimed: number }>('user/setTotalTokenClaimed')
export const setTokenClaimed = createAction<{ tokenClaimed: number }>('user/setTokenClaimed')
export const setRefetch = createAction<{ reFetch: boolean }>('user/setRefetch')
